import React, { useState, useEffect } from 'react';
import {
  Routes, Route, Navigate, useNavigate,
} from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import CheckoutScreenContainer from '../screens/CheckoutScreenContainer';
import {
  ConfirmationScreen,
  ContactScreen,
  CreateScreen,
  PromoteScreen,
  PaymentScreen,
  ReviewScreen,
} from '../screens';

import { checkoutURL } from '../helpers/divewireConstants';

const CheckoutRoutes = () => {
  const { stripePublicKey } = window.divewire;
  const stripePromise = loadStripe(stripePublicKey);

  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialLoad) {
      // when first loading, intercept the Django base route and redirect to the contact screen
      if (window.location.pathname === checkoutURL) {
        navigate(`${checkoutURL}/contact`, { replace: true });
      }
      setIsInitialLoad(false);
    }
  }, [isInitialLoad]);

  return (
    <Routes>
      {/* On initial load, redirect to the ContactScreen (screen #1) */}
      <Route exact path={`${checkoutURL}/`} element={<Navigate to="contact" />} />
      <Route path={`${checkoutURL}`} element={<CheckoutScreenContainer />}>
        <Route path="contact" element={<ContactScreen />} />
      </Route>
      {/* If they somehow get to the root of the checkout, redirect them to the contact screen */}
      <Route exact path={`${checkoutURL}/:token/`} element={<Navigate to="contact" />} />
      <Route path={`${checkoutURL}/:token`} element={<CheckoutScreenContainer />}>
        <Route path="contact" element={<ContactScreen />} />
        <Route path="create" element={<CreateScreen />} />
        <Route path="review" element={<ReviewScreen />} />
        <Route path="promote" element={<PromoteScreen />} />
        <Route
          path="payment"
          element={(
            <Elements stripe={stripePromise}>
              <PaymentScreen />
            </Elements>
          )}
        />
        <Route path="confirmation" element={<ConfirmationScreen />} />
      </Route>
      {/* Fallback to initial contact screen */}
      <Route path="*" element={<Navigate to={`${checkoutURL}/contact`} />} />
    </Routes>
  );
};

export default CheckoutRoutes;
